// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lucy-query-builder-component-container{width:100%;height:100%;overflow:hidden}.lucy-query-builder-error-container{width:100%;height:100%;display:flex;align-items:center;justify-content:center}.lucy-query-builder-error-container .lucy-query-builder-error-messge{text-align:center;color:var(--errorSelectedColor);font-size:14px}", ""]);
// Exports
module.exports = exports;
